import styled from 'styled-components';

const StyledCursor = styled.div`
.cursor {
  position: fixed;
  width: 40px;
  height: 40px;
  background-color: transparent;
  border-radius: 50%;
  top: var(--y, 0);
  left: var(--x, 0);
  transform: translate(-50%, -50%);
  z-index: 10;
  opacity: 1;
  pointer-events: none;
  border: 2px solid ${ props => props.theme.colors.green_secondary};
  transition: opacity .25s ease-out,  width .25s ease-out, height .25s ease-out, background-color .25s ease-out, border-color .25s ease-out;
}
.cursor:after{
  content: 'View';
  opacity: 0;
  position: absolute;
  color: #fff;
  font-size: 14px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  transition: opacity .25s ease-out,
}
.over-cta{
  width: 128px;
  height: 128px;
}
.over-view{
  width: 128px;
  height: 128px;
  background-color: ${ props => props.theme.colors.green_secondary};
}
.over-view.cursor:after{
  opacity: 1;
}
.over-video{
  opacity: 0;
}
`;

export {
  StyledCursor,
};

